import Rules from '@/services/validation/rules/rules'
export default {
  data() {
    return {
      // startRules: [
      //     v => Rules.isRequired(v)
      // ],
      // endRules: [
      //     v => Rules.isRequired(v)
      // ],
      travelRules: [
        v => Rules.maxLength(v, 6),
        v => Rules.isRequiredWithZero(v),
        v => Rules.isNumber(v)
      ],
      wbDocketNumberRules: [
        v => Rules.minLength(v, 1),
        v => Rules.maxLength(v, 50)
      ],
      noteRules: [
        v => Rules.minLength(v, 1),
        v => Rules.maxLength(v, 250),
      ],
      breaksRules: [
        v => Rules.maxLength(v, 6),
        v => Rules.isRequiredWithZero(v),
        v => Rules.isNumber(v)
      ],
      tipRules: [
        v => Rules.isRequired(v)
      ],
      spoilRules: [
        v => Rules.isRequired(v)
      ],
      siteWeightRules: [
        // v => (
        //     !this.end && !this.start && !this.qty ? !!v : true
        // ) || 'Must enter either Tip Weight or start / end times',
        v => {
          var end = this.getValue('end')
          var start = this.getValue('start')
          var qty = this.getValue('qty')
          var travel = this.getValue('travel')
          if ((!end || !start) && !qty && !travel) {
            if (!!v) return true
            else return 'Must enter either Tip Weight or start / end times'
          } else {
            return true
          }
        },
        v => Rules.isMaxNumber(v, 50)
      ],
      scaleWeightRules: [
        v => Rules.isNumber(v),
        v => Rules.isMaxNumber(v, 50)
      ],
      startRules: [
        v => {
          var end = this.getValue('end')
          if (!!end) {
            if (!!v) return true
            else return 'Must enter end and start times'
          } else {
            return true
          }
        },
        // v => (
        //     !this.siteWeight ? !!v : true
        // ) || 'Must enter either Tip Weight or start / end times'
      ],
      endRules: [
        v => {
          var start = this.getValue('start')
          if (!!start) {
            if (!!v) return true
            else return 'Must enter end and start times'
          } else {
            return true
          }
        },
        v => {
          var siteWeight = this.getValue('siteWeight')
          if (!!siteWeight) {
            if (!!v) return true
            else return 'Must enter either Tip Weight or start / end times'
          } else {
            return true
          }
        },
        // v => (
        //     !!this.start ? !!v : true
        // ) || 'Must enter end and start times',
        // v => (
        //     !this.siteWeight ? !!v : true
        // ) || 'Must enter either Tip Weight or start / end times'
      ],
      tipWeightRules: [
        v => Rules.isNumber(v),
        v => Rules.isMaxNumber(v, 50)
      ],
      qtyRules: [
        v => Rules.maxLength(v, 5),
        v => Rules.isNumber(v),
        v => Rules.isRequiredWithZero(v),
      ]

    }
  }
}
